// @flow

// eslint-disable-next-line no-unused-vars
import React, { Fragment } from 'react';
import { last } from 'lodash';

import { Spacer } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import FormNode from 'app/developer-v3/components/PartnerSupportForm/components/Form/Node';
import useTrackPath from 'app/developer-v3/components/PartnerSupportForm/hooks/useTrackPath';
import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';
import {
  NextButton,
  Section,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';

import type { Node } from 'react';

import type { FormActions } from 'app/developer-v3/components/PartnerSupportForm/types';
import type { SelectedNode } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';
import type { States } from 'app/developer-v3/components/PartnerSupportForm/machine';

/** @jsx isolateComponent */

type Props = {
  actions: FormActions,
  nodes: SelectedNode[],
  state: States,
};

const Styles = labelStyles(__filename, {
  questions: {
    display: 'grid',
    gridRowGap: 40,
  },
});

const Questions = ({ actions, nodes, state }: Props): Node => {
  const trackPath = useTrackPath();
  const { size } = useFormContext();

  const questionNodes = nodes.filter(node => node.id !== 'help');
  const isConfirming = state === 'confirm';

  const lastQuestionNode = last(questionNodes);
  const additionalPath = isConfirming ? 'confirm' : '';
  trackPath(lastQuestionNode.pathId, additionalPath);

  const isNextDisabled = !isConfirming;

  return (
    <Section size={size} title="Let’s get you some help">
      <p>Get started by telling us a bit about your question.</p>
      <Spacer height={50} />
      <div css={Styles.questions}>
        {questionNodes.map(node => (
          <FormNode
            actions={actions}
            key={node.pathId}
            node={node}
            state={state}
          />
        ))}
        <NextButton disabled={isNextDisabled} onClick={actions.confirm} />
      </div>
    </Section>
  );
};

export default Questions;
